<div class="form-group form-group--lg mb-0" id="multiselect-example">

  @for (item of items; track item) {
    <label class="custom-input custom-input--checkbox custom-input--benefit">
      @if (question.answer.indexOf(option.answer)>=0) {
        <input type="checkbox" checked value="{{option.answer}}" (click)="checkMultiSelect()" name="{{uniqueControlName}}"/>
      }
      @if (question.answer.indexOf(option.answer)==-1) {
        <input type="checkbox" value="{{option.answer}}"  (click)="checkMultiSelect()" name="{{uniqueControlName}}"/>
      }
      <span class="custom-input__indi"></span>
      <span class="custom-input__label">
        <h5 class="font-16">{{item.name}}</h5>
        <svg class="icon"><use attr.xlink:href="{{item.icon}}"></use></svg>
      </span>
    </label>
  }
</div>